type CaptainCopy = {
  heading: string;
  shortHeading: string;
  body: string;
};

export const emptyResult = { heading: '', shortHeading: '', body: '' };

export const captainNotProvided = {
  heading: 'Self-Captain',
  shortHeading: 'Self-Captain',
  body: 'Customer provides or acts as the qualified operator.',
};

export const captainProvided = {
  heading: 'With Captain',
  shortHeading: 'With Captain',
  body: 'Professional Captain required, arranged and paid for separately through Getmyboat.',
};

export const captainSeparate = {
  heading: 'With Captain',
  shortHeading: 'With Captain',
  body: 'Professional Captain required, arranged and paid for separately through Getmyboat.',
};

const getCaptainedCopy = (captained?: boolean, captainedCost?: boolean): CaptainCopy => {
  if (captained === undefined || captainedCost === undefined) {
    return emptyResult;
  }

  if (!captained) {
    return captainNotProvided;
  }

  return captainProvided || captainSeparate;
};

export default getCaptainedCopy;
